import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import CertificateDescription from './NotificationDescription';
import DownloadButton from './DownloadButton';
import { CONSTANTS } from '../../../constants/constants';
import FlowSteps from '../../UI/FlowSteps';

const styles = {
  descriptionGrid: {
    paddingLeft: 16
  },
  bottomLineGrid: {
    borderBottom: '1px solid #DEDEDE',
    marginBottom: 10,
    marginTop: 3
  },
  bottomLineGridSmall: {
    borderBottom: '1px solid #DEDEDE',
    marginBottom: 20,
    marginTop: 12
  }
};

const CertificateCard = (props) => {
  const { document } = props;
  const isMobile = useMediaQuery('(max-width: 500px)');

  return (
    <Grid container direction='row' alignItems='center'>
      {!isMobile ? (
        <>
          <Grid
            item
            xl={2}
            xs={2}
            style={styles.descriptionGrid}
          >
            <CertificateDescription document={document} />
          </Grid>
          <Grid
            item
            xl={document.status === CONSTANTS.DOCUMENT.STATUS.INIT ? 5 : 6}
            xs={document.status === CONSTANTS.DOCUMENT.STATUS.INIT ? 1 : 6}
          >
            {document.flow && <FlowSteps document={document} skip={2} nonLinear fullWidth />}
          </Grid>
          <Grid
            item
            container
            spacing={1}
            justify='flex-end'
            alignItems='center'
            xl={document.status === CONSTANTS.DOCUMENT.STATUS.INIT ? 5 : 4}
            xs={document.status === CONSTANTS.DOCUMENT.STATUS.INIT ? 9 : 4}
          >
            <DownloadButton document={document} />
          </Grid>
          <Grid
            item
            xs={12}
            style={styles.bottomLineGrid}
          />
        </>
      ) : (
        <>
          <Grid item xs={11}>
            <CertificateDescription document={document} showImage />
          </Grid>
          <Grid
            item
            xs={1}
          >
            <DownloadButton document={document} />
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 10, paddingTop: 8 }}>
            {document.status !== CONSTANTS.DOCUMENT.STATUS.INIT &&
              <Typography variant='subtitle1' style={{ color: 'rgba(0, 0, 0, 0.60)' }}>Firmas Necesarias</Typography>}
            {document.flow && <FlowSteps document={document} skip={2} nonLinear fullWidth />}
          </Grid>
          <Grid item xs={12} style={styles.bottomLineGridSmall} />
        </>
      )}
    </Grid>
  );
};

CertificateCard.propTypes = {
  document: PropTypes.object.isRequired
};

export default CertificateCard;
